import Cookies from 'js-cookie'

const TokenKey = 'b2b_token';
const potTokenKey = 'b2b_potTokenKey';

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: 7, path: '/' });
}

export function getPotToken() {
  return Cookies.get(potTokenKey);
}

export function setPotToken(token) {
  return Cookies.set(potTokenKey, token, { expires: 7, path: '/' });
}

export function removeToken() {
  return Cookies.remove(TokenKey, { path: '/' });
}



// WEBPACK FOOTER //
// ./src/utils/auth.js